import {
  useNavigate,
  useParams as useTanstackParams,
  useRouterState,
} from '@tanstack/react-router'

export function useRouter() {
  const navigate = useNavigate()
  return {
    push: (url: string, _opts?: { scroll?: boolean }) => {
      void navigate({ to: url })
    },
    replace: (url: string) => {
      void navigate({ to: url, replace: true })
    },
    prefetch: async () => {},
    back: () => {
      window.history.back()
    },
    forward: () => {
      window.history.forward()
    },
    refresh: () => {
      window.location.reload()
    },
  }
}

export function useParams<T extends Record<string, string | undefined> = Record<string, string | undefined>>() {
  // Relax types a bit – we don't need strict param inference here,
  // just a convenient wrapper that mirrors Next.js' `useParams`.
  return useTanstackParams({ strict: false } as any) as T
}

export function usePathname() {
  return useRouterState({ select: (s) => s.location.pathname })
}

export function useSearchParams() {
  // TanStack `location.search` is a parsed object; use `searchStr` for the raw query.
  const search = useRouterState({
    select: (s) => s.location.searchStr ?? '',
  })
  const q = search.startsWith('?') ? search.slice(1) : search
  return new URLSearchParams(q)
}
